/**
 * McpServiceStandalone — STUB; standalone host has no MCP backends.
 *
 * Symmetric with LlmServiceStandalone: the downloadable HTML bundle
 * runs without the per-tenant MIND/SIGHT/CORTEX backends, so knowledge
 * features degrade. UI hides the knowledge surface when isAvailable
 * returns false.
 *
 * No M4 work changes this — standalone is permanently MCP-less. Future
 * v1.1 might pre-bake selected knowledge into the standalone bundle
 * (M4 degradation-matrix entry), but that's a static lookup, not MCP.
 */
import type { McpService } from '../types';
import { ServiceUnavailableError } from '../types';

export class McpServiceStandalone implements McpService {
  isAvailable(): boolean {
    return false;
  }

  async query<T = unknown>(_tool: string, _args: Record<string, unknown>): Promise<T> {
    throw new ServiceUnavailableError(
      'McpServiceStandalone.query',
      'standalone_host_has_no_mcp',
    );
  }
}
